import { ActionIcon, Tooltip } from '@mantine/core';
import { IconBook2 } from '@tabler/icons-react';
import * as React from 'react';
import { useNestedDialogFunction } from '../../../../../react-commons/dialog-provider/UseNestedDialogFunction';
import { OpenModal } from '../../../../../react-commons/utils/modals/openModal';
import { PersistableInfo } from '../../../resource/resource-base/persistableResourceTypes';
import { TOOLTIPS } from '../../../resource/tooltipTexts';
import { MetaDataDialogContent } from '../dialogs/MetaDataDialogContent';
import { Show } from '../../../../../react-commons/components/control-flow/Show';
import { useParams } from 'react-router-dom';
import { useUserId } from '../../authentication/useUserId';
import { useUserActions } from '../../../resource/resources/persistables/user/userResource';

export const MetaDataButton= ({ metaDataInfo, versionMetaDataInfo, style }: {
    metaDataInfo: {
        id: string;
        objectId: string;
        persistableInfo: PersistableInfo;
    };
    versionMetaDataInfo?: {
        id: string;
        objectId: string;
        persistableInfo: PersistableInfo;
    } | null;
    style?: React.CSSProperties;
}) => {
    const nestedDialog = useNestedDialogFunction();
    const userId = useUserId('');
    const { id: projectId } = useParams<{ id: string }>();
    const userActions = useUserActions();
    const userSystemRights = userActions.useGetUserEffectiveRightsOfUser(userId, projectId);
    const isProcessAdmin =
        userSystemRights.data?.isProcessAdmin;

    const openValidationDialog = () => {
        OpenModal.ContentModal({
            title: 'Resource Metadata',
            content: <MetaDataDialogContent
                close={nestedDialog.closeNestedDialog}
                metaDataInfo={metaDataInfo}
                versionMetaDataInfo={versionMetaDataInfo}
            />,
        });
    };

    return (
        <Show when={isProcessAdmin}>
            <Tooltip label={TOOLTIPS.METADATA}>
                <ActionIcon
                    style={{ padding: '6px', backgroundColor: 'inherit', ...style }}
                    size={'sm'}
                    variant={'transparent'}
                    color={'var(--mantine-color-base-button)'}
                    onClick={openValidationDialog}
                >
                    <IconBook2 />
                </ActionIcon>
            </Tooltip>
        </Show>
    );
};


